
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Wer drei Monate lang an 10 oder mehr Tagen monatlich Medikamente gegen die
Kopfschmerzen braucht, läuft Gefahr, einen Müks
(Medikamenten-Übergebrauch-Kopfschmerz) zu entwickeln, und sollte sich ärztliche
Hilfe holen. Bei einfachen Schmerzmitteln wie zum Beispiel Aspirin, Dafalgan
oder Ibuprofen läuft man ab einer Einnahme von 15 Tagen oder mehr pro Monat
Gefahr, einen Müks zu entwickeln. Die wichtigste Faustregel lautet aber «10–20»:
An weniger als an 10 Tagen pro Monat sollen Akutmedikamente gegen Kopfschmerzen
eingenommen werden, an mindestens 20 Tagen im Monat sollen keine Schmerz- oder
Migränemittel verwendet werden.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;